import { ElementType } from 'react';
import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';

const PREFIX = 'ProfileRow';

const classes = {
  row: `${PREFIX}-row`,
  iconAndText: `${PREFIX}-icon-and-text`,
  label: `${PREFIX}-label`,
  value: `${PREFIX}-value`,
};

const StyledBox = styled(Box)(({ theme }) => ({
  [`&.${classes.row}`]: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: theme.spacing(4),
  },

  [`& .${classes.iconAndText}`]: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing(1.5),
  },

  [`& .${classes.label}`]: {
    fontSize: 14,
    fontWeight: '400',
    fontStyle: 'normal',
    lineHeight: '143%',
    letterSpacing: '0.17px',
    color: theme.palette.lightTextPrimary.main,
  },

  [`& .${classes.value}`]: {
    fontSize: 14,
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '157%',
    letterSpacing: '0.1px',
    textAlign: 'right',
    color: theme.palette.lightTextPrimary.main,
  },
}));

interface ProfileRowProps {
  label: string;
  value: string | undefined;
  icon: ElementType;
  testidPrefix?: string;
}

export default function ProfileRow({
  label,
  value,
  icon: Icon,
  testidPrefix = 'passenger-profile',
}: ProfileRowProps) {
  return (
    <StyledBox className={classes.row} data-testid={`${testidPrefix}-row`}>
      <Box className={classes.iconAndText}>
        <Icon color="info" data-testid={`${testidPrefix}-icon`} />
        <Typography
          className={classes.label}
          data-testid={`${testidPrefix}-label`}>
          {label}
        </Typography>
      </Box>
      <Typography
        className={classes.value}
        data-testid={`${testidPrefix}-value`}>
        {value}
      </Typography>
    </StyledBox>
  );
}
